import Sidebar from '../../components/widgets/sidebar';
import SidebarBase from './Base';

export default class Admin extends SidebarBase {

  render() {
    return (
      <>
        <Sidebar.Item text="سنسور" icon="fal fa-sensor">
          <Sidebar.Item path="/dashboard/create-sensor" text="سنسور جدید" />
          <Sidebar.Item path="/dashboard/sensors" text="لیست سنسورها" />
          <Sidebar.Item path="/dashboard/sensors/edit/Default" text="سنسور پیشفرض" />
          <Sidebar.Item path="/dashboard/unknown-sensors" text="سنسورهای ناشناخته" />
        </Sidebar.Item>
        <Sidebar.Item text="کاربران" icon="fal fa-user">
          <Sidebar.Item path="/dashboard/create-user" text="کاربر جدید" />
          <Sidebar.Item path="/dashboard/users" text="لیست کاربران" />
        </Sidebar.Item>
        <Sidebar.Item path="/dashboard/alarms" text="هشدارها" icon="fal fa-exclamation-triangle" {...this.getBadge()} />
        <Sidebar.Item path="/dashboard/firmwares" text="بروزرسانی" icon="fal fa-wrench" />
        <Sidebar.Item path="/dashboard/collections" text="بانک اطلاعاتی" icon="fal fa-database" />
        <Sidebar.Item path="/dashboard/storage" text="ذخیره سازی" icon="fal fa-hdd" />
        <Sidebar.Item path="/dashboard/monitor" text="مانیتور سیستم" icon="fal fa-monitor-heart-rate" />
      </>
    );
  }

}
